import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import RitualNavigation from "../components/ritual/RitualNavigation";
import RitualFooter from "../components/ritual/RitualFooter";
import HeroSection from "../components/ritual/HeroSection";
import SlowMadeCarousel from "../components/ritual/SlowMadeCarousel";
import SustainabilitySection from "../components/ritual/SustainabilitySection";
import MaterialsSection from "../components/ritual/MaterialsSection";
import InstagramSection from "../components/ritual/InstagramSection";
import designerImage from "@/assets/Camila2.jpg?format=webp";

const Index = () => {
  const { hash } = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    const timer = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, [hash]);

  return (
    <div className="min-h-screen bg-background">
      <RitualNavigation />

      <main>
        <HeroSection />
        <section id="silhouettes"><SlowMadeCarousel /></section>

        {/* ── The Maker teaser ── */}
        <section id="my-story" className="w-full py-20 md:py-32 px-6">
          <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20 items-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease: "easeOut" }}
              className="space-y-6"
            >
              <div className="gold-line" />
              <p className="font-body text-xs tracking-[0.3em] uppercase text-gold">
                {t("index.makerLabel")}
              </p>
              <h2 className="font-display text-3xl md:text-4xl text-foreground leading-tight">
                {t("index.makerName")}
              </h2>
              <p className="font-body text-sm text-muted-foreground leading-relaxed">
                {t("index.makerBio")}
              </p>
              <Link
                to="/about/our-story"
                className="inline-block font-body text-xs tracking-[0.15em] uppercase text-foreground border-b border-foreground pb-0.5 hover:text-gold hover:border-gold transition-colors duration-500"
              >
                {t("index.readStory")}
              </Link>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1.2, delay: 0.2 }}
              className="hidden md:block"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={designerImage}
                  alt="Camila Luna"
                  className="w-full h-full object-contain"
                  style={{
                    maskImage: "radial-gradient(circle, black 60%, transparent 100%)",
                    WebkitMaskImage: "radial-gradient(circle, black 60%, transparent 100%)",
                  }}
                />
              </div>
            </motion.div>
          </div>
        </section>

        <section id="sustainability"><SustainabilitySection /></section>
        <section id="materials"><MaterialsSection /></section>
        <section id="instagram"><InstagramSection /></section>
      </main>

      <RitualFooter />
    </div>
  );
};

export default Index;
